import { dateField } from 'drapcode-constant';
import { getCollectionFields } from '../pluginComponentApi';

export default function (editor, opts = {}) {
  const { collections } = opts;
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('date-range-filter', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          tagName: 'div',
          'custom-name': 'Date Range Pagination',
          icon: '<i class="wb webconnect-subtract"></i>',
          draggable: '.data-table, .data-group', // Can be dropped only inside `data-table and data-group` elements
          droppable: false, // Can't drop other elements inside
          traits: [
            ...domc.getType('table').model.prototype.defaults.traits,
            {
              type: 'select',
              label: 'Field',
              name: 'collectionField',
              changeProp: 1,
              options: [],
            },
            {
              type: 'select',
              label: 'Type',
              name: 'rangeType',
              changeProp: 1,
              options: [
                { value: 'day', name: 'Day' },
                { value: 'week', name: 'Week' },
                { value: 'month', name: 'Month' },
                { value: 'year', name: 'Year' },
              ],
              value: '',
            },
          ],
        },
        async init() {
          const collectionFieldTrait = this.getTrait('collectionField');
          const collectionName = findCollectionNameFromDataTable(this);
          if (collectionName) {
            const { fields } = await getCollectionFields(collectionName, collections);
            const fieldsOptions = getDateFieldsOptions(fields);
            collectionFieldTrait.set('options', fieldsOptions);
          }
          this.on('change:collectionField', this.handleFieldChange);
          this.on('change:rangeType', this.handleRangeTypeChange);
        },

        handleFieldChange() {
          const collectionField = this.get('collectionField');
          const attrs = this.getAttributes();
          attrs['date-field'] = collectionField;
          this.setAttributes(attrs);
        },
        handleRangeTypeChange() {
          const rangeType = this.get('rangeType');
          const attrs = this.getAttributes();
          attrs['date-range-type'] = rangeType;
          this.setAttributes(attrs);
        },
      },

      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'date-range-filter') {
            return {
              type: 'date-range-filter',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init() {},
    }),
  });
}

const findCollectionNameFromDataTable = (component) => {
  const dataTable = component.closestType('data-table');
  const dataGroup = component.closestType('data-group');
  const calendar = component.closestType('calendar');
  let collectionName = component.get('collectionName');
  if (dataTable) {
    collectionName = dataTable.get('collectionName');
  } else if (dataGroup) {
    collectionName = dataGroup.get('collectionName');
  } else if (calendar) {
    collectionName = calendar.get('collectionName');
  }
  return collectionName;
};

const getDateFieldsOptions = (fields) => {
  return fields
    ? fields
        .filter((field) => [...dateField].includes(field.type))
        .map((field) => ({
          id: field.fieldName,
          name: field.fieldTitle.en,
        }))
    : [];
};
